import { render, staticRenderFns } from "./brands.vue?vue&type=template&id=3eb909d0&scoped=true&"
import script from "./brands.vue?vue&type=script&lang=ts&"
export * from "./brands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb909d0",
  null
  
)

export default component.exports